export const guestStartModalStyles = {
  'abyss-modal-base-header-container': {
    padding: '16px',
  },
  'abyss-modal-base-body': {
    rowGap: '8px',
  },
};
